import BigNumber from "bignumber.js";

const TWO_DECIMAL_REGEX = /^-?\d+(\.\d{1,2})?$/;

export function validateTwoDecimal(number) {
  return TWO_DECIMAL_REGEX.test(number);
}

export function formatThousandsSeparator(value) {
  if (value === null || value === undefined || value === "") return "";
  const str = String(value).trim();
  if (!str || str === "-") return str;
  const bn = new BigNumber(str);
  if (!bn.isFinite()) return str;
  return bn.toNumber().toLocaleString("en-US");
}